export const environment = {
  production: false,
  API_URL: 'https://TestSmartAccuPay.smartaccupay.com:4207/',
  PLAN_URL: 'https://test.smartaccupay.com/superadmin/authentication/registration-form?plan=',
  STRIPE_KEY: "pk_test_51QSdpzDlOxeHraFmH4Y6oHUPa11QFtpFFyQ1F5AgjONT3078RJNqd6v0KjTSHjrWJQvxCVmqQrhpMW9QiqfEXuEb00Uz0Y6zLu",
  QUICKBOOKS_CLIENT_ID: 'ABjPluRwIqH6dfalr4TasRbV16CCzfHzGiXoYqEpIG6klgooK0',
  QUICKBOOKS_CLIENT_SECRET: 'izeuxKkVfZcNptdidDPfcOL8p4wLN2xubQ6Ynjfm',
  QUICKBOOKS_ENVIRONMENT: 'sandbox',
  QUICKBOOKS_REDIRECT_URL: 'https://test.smartaccupay.com/settings/view-integration/',
};
